import type {ReactElement} from 'react';
import React from 'react';
import {useGetSelectedTranscriptItem} from '@Hooks/poster-editor/useGetSelectedTranscriptItem';
import type {RGBA} from '@Utils/color.util';
import {BaseOutlineColorPanel} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-outline-color-panel';
import {useGetKeyFromSubtitleTextStylesForTranscriptItem} from '@Hooks/poster-editor/useGetKeyFromSubtitleTextStylesForTranscriptItem';

export function TranscriptSentenceOutlineColorPanel(): ReactElement<any> {
  const activeItem = useGetSelectedTranscriptItem();
  if (activeItem === null) {
    throw new Error('Transcript Item is undefined in TranscriptSentenceOutlineColorPanel');
  }

  const strokeColor = useGetKeyFromSubtitleTextStylesForTranscriptItem('strokeColor', false);
  if (strokeColor === undefined) {
    throw new Error('Transcript Item does not have strokeColor property in sentenceTextStyles');
  }

  const onSentenceStrokeColorChange = (strokeColor: RGBA, undoable = true): void => {
    void activeItem.updateAllSubtitlesStylesFromSubtitleObject(
      {
        sentenceTextStyles: {
          strokeColor,
        },
      },
      {undoable}
    );
  };

  return <BaseOutlineColorPanel strokeColor={strokeColor} onUpdateStrokeColor={onSentenceStrokeColorChange} />;
}
